// frontend/src/components/UI/OwnershipBadge.js
/**
 * Procurement-class badge for assets (Owned / Leased).
 *
 * Ownership is NOT a workflow status — do not use StatusBadge.
 * List views only render Leased (exception); Owned stays silent as the default.
 * Pass `showOwned` when the context needs both labels (e.g. detail headers).
 */
import React from 'react';
import { InfoBadge } from './InfoBadge';
import { OWNERSHIP_OPTIONS } from '../../constants/assetOptions';

const COLOR_BY_VALUE = {
  owned: 'slate',
  leased: 'indigo',
};

export const getOwnershipLabel = (ownershipType) => {
  if (!ownershipType) return '';
  const match = OWNERSHIP_OPTIONS.find((o) => o.value === ownershipType);
  return match?.label || ownershipType;
};

/**
 * @param {object} props
 * @param {string} [props.ownershipType] - Asset.ownership_type value
 * @param {boolean} [props.showOwned=false] - When false, owned renders null (list default)
 * @param {'xs'|'md'} [props.size='xs']
 * @param {string} [props.className]
 */
export const OwnershipBadge = ({
  ownershipType,
  showOwned = false,
  size = 'xs',
  className = '',
}) => {
  if (!ownershipType) return null;
  if (ownershipType === 'owned' && !showOwned) return null;

  const label = getOwnershipLabel(ownershipType);
  if (!label) return null;

  return (
    <InfoBadge
      color={COLOR_BY_VALUE[ownershipType] || 'gray'}
      label={label}
      size={size}
      className={className}
      title={`Ownership: ${label}`}
    />
  );
};

export default OwnershipBadge;
